<template>
    <div class="w-full flex flex-row flex-wrap justify-center">
        <avatar v-for="receipt in receipts"
            :username="receipt.user.name"
            :size="25"
            :title="receipt.user.name + ' at ' + displayLocalDateTime(receipt.read_at)" 
            v-tippy
            class="ml-1 mt-1">
        </avatar>
        <!-- <span ">{{ receipt.user.name }}</span> -->
    </div>
</template>

<script>
    import Avatar from 'vue-avatar'
    import moment from 'moment';

	export default {
		name: 'AnnouncementReceipt',
        props: [
            'receipts',
        ],
        components: {
            'avatar': Avatar
        },
        methods: {
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm A');
            }
        },
	}
</script>